"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectorAutocomplete = exports.TYPE_SELECTOR_HEIGHT = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const material_1 = require("@mui/material");
const react_1 = require("react");
const autocomplete_dropdown_1 = require("./autocomplete-dropdown");
const main_1 = require("./main");
const popper_placement_modifier_1 = require("./popper-placement-modifier");
const selector_autocomplete_option_1 = require("./selector-autocomplete/selector-autocomplete-option");
exports.TYPE_SELECTOR_HEIGHT = 57;
const DropdownPropsContext = (0, react_1.createContext)(null);
const useDropdownProps = () => {
    const value = (0, react_1.useContext)(DropdownPropsContext);
    if (!value) {
        throw new Error("Dropdown props context provider missing");
    }
    return value;
};
const TypeListSelectorDropdown = ({ children, ...props }) => {
    const { query, createButtonProps, variant } = useDropdownProps();
    return ((0, jsx_runtime_1.jsxs)(autocomplete_dropdown_1.AutocompleteDropdown, { ...props, inputHeight: exports.TYPE_SELECTOR_HEIGHT, children: [children, createButtonProps ? ((0, jsx_runtime_1.jsxs)(main_1.Button, { variant: "tertiary", startIcon: (0, jsx_runtime_1.jsx)(main_1.StyledPlusCircleIcon, {}), sx: {
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    mt: 1,
                }, ...createButtonProps, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "smallTextLabels", sx: (theme) => ({
                            color: theme.palette.gray[60],
                            fontWeight: 500,
                        }), children: "Create" }), query ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["\u00A0", (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "smallTextLabels", sx: (theme) => ({
                                    color: theme.palette.gray[60],
                                    fontWeight: 600,
                                }), children: query })] })) : null, variant === "entityType" ? ((0, jsx_runtime_1.jsx)(main_1.Chip, { color: "teal", label: "ENTITY TYPE", sx: { ml: 1.5 } })) : variant === "entity" ? ((0, jsx_runtime_1.jsx)(main_1.Chip, { color: "teal", label: "ENTITY", sx: { ml: 1.5 } })) : variant === "linkType" ? ((0, jsx_runtime_1.jsx)(main_1.Chip, { color: "turquoise", label: "LINK TYPE", sx: { ml: 1.5 } })) : ((0, jsx_runtime_1.jsx)(main_1.Chip, { color: "purple", label: "PROPERTY TYPE", sx: { ml: 1.5 } }))] })) : null] }));
};
const SelectorAutocomplete = ({ open, optionToRenderData, sx, inputRef, inputPlaceholder, dropdownProps, autoFocus = true, modifiers, joined, ...rest }) => {
    const allModifiers = (0, react_1.useMemo)(() => [
        popper_placement_modifier_1.addPopperPositionClassPopperModifier,
        // We don't want the popup shifting position as that will break styles
        { name: "preventOverflow", enabled: false },
        ...(modifiers ?? []),
    ], [modifiers]);
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    return ((0, jsx_runtime_1.jsx)(DropdownPropsContext.Provider, { value: dropdownProps, children: (0, jsx_runtime_1.jsx)(material_1.Autocomplete, { open: open, sx: [{ width: "100%" }, ...(Array.isArray(sx) ? sx : [sx])], 
            /**
             * By default, the anchor element for an autocomplete dropdown is the
             * input base, but we some uses of this component depend on resizing the
             * autocomplete root in order to attach the popup in a slightly different
             * place, so we make the autocomplete root the anchor element for the
             * popup.
             *
             * @see LinkEntityTypeSelector
             */
            ref: setAnchorEl, renderInput: (props) => ((0, jsx_runtime_1.jsx)(main_1.TextField, { ...props, autoFocus: autoFocus, inputRef: inputRef, placeholder: inputPlaceholder, sx: { width: "100%" }, 
                /**
                 * Prevents backspace deleting chips when in multiple mode
                 * @see https://github.com/mui/material-ui/issues/21129#issuecomment-636919142
                 */
                onKeyDown: (event) => {
                    if (event.key === "Backspace") {
                        event.stopPropagation();
                    }
                }, InputProps: {
                    ...props.InputProps,
                    endAdornment: ((0, jsx_runtime_1.jsx)(main_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSearch, sx: (theme) => ({
                            fontSize: 12,
                            mr: 2,
                            color: theme.palette.gray[50],
                        }) })),
                    sx: [
                        (theme) => ({
                            // The popover needs to know how tall this is to draw
                            // a shadow around it
                            height: exports.TYPE_SELECTOR_HEIGHT,
                            // Focus is handled by the options popover
                            "&.Mui-focused": {
                                boxShadow: "none",
                            },
                            [`.${material_1.outlinedInputClasses.notchedOutline}`]: {
                                border: `1px solid ${theme.palette.gray[30]} !important`,
                            },
                        }),
                        ...(open
                            ? [
                                popper_placement_modifier_1.popperPlacementInputNoRadius,
                                popper_placement_modifier_1.popperPlacementInputNoBorder,
                                joined
                                    ? { borderRadius: "0 !important", boxShadow: "none" }
                                    : {},
                            ]
                            : []),
                    ],
                } })), renderOption: (props, option) => {
                const optionRenderData = optionToRenderData(option);
                return ((0, jsx_runtime_1.jsx)(selector_autocomplete_option_1.SelectorAutocompleteOption, { liProps: props, ...optionRenderData }, optionRenderData.$id));
            }, popupIcon: null, disableClearable: true, forcePopupIcon: false, selectOnFocus: false, openOnFocus: true, clearOnBlur: false, getOptionLabel: (opt) => optionToRenderData(opt).title, PaperComponent: TypeListSelectorDropdown, componentsProps: {
                popper: { modifiers: allModifiers, anchorEl },
            }, ...rest }) }));
};
exports.SelectorAutocomplete = SelectorAutocomplete;
